//
// ImageElementController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./VisualElementController";
import "../../models/visualElements/ImageElement";
import "@sas-dvr/ltjs-commons/resources/network/URL";

var ImageElementController = createModule("BIRD::ImageElementController", ["BIRD::BIRDModelController","BIRD::RendererManagerController","BIRD::VisualElementController"], EventDispatcher, [
    {
        FILE_MISSING: 50006,
        IMAGE_DOWNLOAD_OK: 50016,
        IMAGE_DOWNLOAD_FAIL: 50017,
    },
    ,
    ,
    ,
    {
        didAttemptDownload: [0,2],
        getModel: [1],
        getImageLocalFilePath: [7],
        willAttemptDownload: [0],
        showTooltip: [0,7,4,4],
        downloadImage: [0],
        getImageRemoteURL: [1],
    },
    {
        _create: [4,1],
    },
    ,
]);
export default ImageElementController;
